const getComponentSize = (isMobile) => {
  return isMobile ? "s" : "m";
};

export { getComponentSize };
